/**
 * @generated SignedSource<<3357ca4146afdc80798343e4a674bf73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeOffEffortInputs_account$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"EffortInput_account" | "TotalEffortInput_account">;
  readonly " $fragmentType": "TimeOffEffortInputs_account";
};
export type TimeOffEffortInputs_account$key = {
  readonly " $data"?: TimeOffEffortInputs_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeOffEffortInputs_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeOffEffortInputs_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EffortInput_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TotalEffortInput_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "f2bd31e9e068bf07b419b60280818b87";

export default node;
